import { Card, Typography, Button } from 'antd';
import {
  WalletOutlined,
  StockOutlined,
  RiseOutlined,
  FallOutlined,
  CalendarOutlined,
  FundOutlined,
  BankOutlined,
  FileTextOutlined,
  TrophyOutlined,
  DollarOutlined,
  CreditCardOutlined,
  PercentageOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { getInsights, Insight } from '../../../Utils/insightsUtils';
import styles from './index.module.css';

const getIcon = (iconName: string, color: string) => {
  const iconStyle = { fontSize: 20, color };

  switch (iconName) {
    case 'wallet':
      return <WalletOutlined style={iconStyle} />;
    case 'stock':
      return <StockOutlined style={iconStyle} />;
    case 'rise':
      return <RiseOutlined style={iconStyle} />;
    case 'fall':
      return <FallOutlined style={iconStyle} />;
    case 'calendar':
      return <CalendarOutlined style={iconStyle} />;
    case 'fund':
      return <FundOutlined style={iconStyle} />;
    case 'bank':
      return <BankOutlined style={iconStyle} />;
    case 'file':
      return <FileTextOutlined style={iconStyle} />;
    case 'trophy':
      return <TrophyOutlined style={iconStyle} />;
    case 'dollar':
      return <DollarOutlined style={iconStyle} />;
    case 'credit-card':
      return <CreditCardOutlined style={iconStyle} />;
    case 'percentage':
      return <PercentageOutlined style={iconStyle} />;
    default:
      return <WalletOutlined style={iconStyle} />;
  }
};

const InsightItem: React.FC<{ insight: Insight }> = ({ insight }) => {
  return (
    <div className={styles.insightItem}>
      <div
        className={styles.iconContainer}
        style={{ backgroundColor: `${insight.color}15` }}
      >
        {getIcon(insight.icon, insight.color)}
      </div>
      <div className={styles.contentContainer}>
        <Typography.Text className={styles.title}>
          {insight.title}
        </Typography.Text>
        <Typography.Text className={styles.description}>
          {insight.description}
        </Typography.Text>
      </div>
    </div>
  );
};

type InsightsProps = {
  onViewAll?: () => void;
};

const Insights: React.FC<InsightsProps> = ({ onViewAll }) => {
  const insightsList = getInsights();
  const INITIAL_COUNT = 3;

  if (insightsList.length === 0) {
    return null;
  }

  const displayedInsights = insightsList.slice(0, INITIAL_COUNT);
  const hasMore = insightsList.length > INITIAL_COUNT;

  return (
    <Card
      className={styles.insightsCard}
      title={
        <Typography.Text className={styles.cardTitle}>
          Financial Insights
        </Typography.Text>
      }
    >
      <div className={styles.insightsList}>
        {displayedInsights.map((insight) => (
          <InsightItem key={insight.id} insight={insight} />
        ))}
      </div>
      {hasMore && onViewAll && (
        <div className={styles.viewAllContainer}>
          <Button
            type='link'
            className={styles.viewAllButton}
            onClick={onViewAll}
          >
            View All ({insightsList.length}) <RightOutlined />
          </Button>
        </div>
      )}
    </Card>
  );
};

export default Insights;
